import { render, staticRenderFns } from "./AccOrderListItem.vue?vue&type=template&id=2000aff0"
import script from "./AccOrderListItem.vue?vue&type=script&lang=js"
export * from "./AccOrderListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports